<script lang="ts">
import { defineComponent } from 'vue';
import { useCopilotButton } from './useCopilotButton';

export default defineComponent({
  name: 'RoseButton',
  emits: ['open'],
  setup(_: unknown, { emit }: { emit: (event: string) => void }) {
    const { isHovered, setHovered } = useCopilotButton();
    const onClick = () => emit('open');
    return { isHovered, setHovered, onClick };
  },
});
</script>

<template>
  <button
    class="fixed bottom-[5.8rem] right-[1.1rem] z-50 rounded-full shadow-lg bg-white hover:scale-105 transition-transform w-16 h-16 flex items-center justify-center border-2 border-white"
    @click="onClick"
    @mouseenter="setHovered(true)"
    @mouseleave="setHovered(false)"
    aria-label="Abrir chat com Rose"
    type="button"
  >
    <img src="../../assets/imgs/rose.png" alt="Rose" class="w-18 h-18 rounded-full object-cover" />
    <span
      v-if="isHovered"
      class="absolute -top-8 right-0 bg-white text-gray-800 px-3 py-1 rounded shadow text-xs font-semibold w-24 text-center"
      >Fale com a Rose</span
    >
  </button>
</template>
